export type CompareCheckboxInfo = {
  name?: string;
  label: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  heading?: string;
};

export const defaultItems: CompareCheckboxInfo[] = [
  {
    name: 'reviews',
    label: 'Ratings',
    isChecked: true,
  },
  {
    name: 'tierOneProvider',
    label: 'Tier 1 provider',
    isChecked: true,
  },
  {
    name: 'tierOneAndTwoProvider',
    label: 'Tier 1 & Tier 2 provider',
    isChecked: true,
  },
  {
    name: 'education',
    label: 'Education',
    isChecked: false,
  },
  {
    name: 'languagesSpoken',
    label: 'Language(s) spoken',
    isChecked: false,
  },
  {
    name: 'cost',
    label: 'Cost',
    isChecked: true,
  },
  {
    name: 'specialties',
    label: 'Specialty',
    isChecked: true,
  },
  {
    name: 'distance',
    label: 'Distance from me',
    isChecked: true,
  },
  {
    name: 'acceptingNewPatients',
    label: 'Accepting new patients',
    isChecked: false,
  },
  {
    name: 'gender',
    label: 'Gender',
    isChecked: false,
  },
  {
    name: 'virtualCareOffered',
    label: 'Virtual care offered',
    isChecked: false,
  },
  {
    name: 'hoursOfOperation',
    label: 'Hours of operation',
    isChecked: false,
  },
  {
    name: 'premiumCareProvider',
    label: 'Premium Care Physician',
    isChecked: true,
  },
  {
    name: 'hasPCPServiceAvailability',
    label: 'PCP services available',
    isChecked: false,
  },
  {
    name: 'ethnicity',
    label: 'Ethnicity',
    isChecked: false,
  },
  {
    name: 'race',
    label: 'Race',
    isChecked: false,
  },
];

export const bhSpecificDefaultItems: CompareCheckboxInfo[] = [
  {
    name: 'reviews',
    label: 'Ratings',
    isChecked: true,
  },
  {
    name: 'education',
    label: 'Education',
    isChecked: true,
  },
  {
    name: 'languagesSpoken',
    label: 'Language(s) spoken',
    isChecked: false,
  },
  {
    name: 'cost',
    label: 'Cost',
    isChecked: true,
  },
  {
    name: 'specialties',
    label: 'Specialty',
    isChecked: true,
  },
  {
    name: 'distance',
    label: 'Distance from me',
    isChecked: true,
  },
  {
    name: 'acceptingNewPatients',
    label: 'Accepting new patients',
    isChecked: false,
  },
  {
    name: 'gender',
    label: 'Gender',
    isChecked: false,
  },
  {
    name: 'virtualCareOffered',
    label: 'Virtual care offered',
    isChecked: false,
  },
  {
    name: 'hoursOfOperation',
    label: 'Hours of operation',
    isChecked: false,
  },
  {
    name: 'providerEthnicityExpress',
    label: 'Provider ethnicity',
    isChecked: false,
  },
  {
    name: 'eapAccepted',
    label: 'Employee Assistance Program accepted',
    isChecked: false,
  },
  {
    name: 'hasEveningAppointments',
    label: 'Offers evening appointments',
    isChecked: false,
  },
  {
    name: 'hasWeekendAppointment',
    label: 'Offers weekend appointments',
    isChecked: false,
  },
  {
    name: 'practiceLimitations',
    label: 'Practice limitations',
    isChecked: false,
  },
];

export const visionSpecificDefaultItems: CompareCheckboxInfo[] = [
  {
    name: 'reviews',
    label: 'Ratings',
    isChecked: true,
  },
  {
    name: 'languagesSpoken',
    label: 'Language(s) spoken',
    isChecked: false,
  },
  {
    name: 'cost',
    label: 'Cost',
    isChecked: true,
  },
  {
    name: 'specialties',
    label: 'Specialty',
    isChecked: true,
  },
  {
    name: 'distance',
    label: 'Distance from me',
    isChecked: true,
  },
  {
    name: 'acceptingNewPatients',
    label: 'Accepting new patients',
    isChecked: false,
  },
  {
    name: 'gender',
    label: 'Gender',
    isChecked: false,
  },
  {
    name: 'hoursOfOperation',
    label: 'Hours of operation',
    isChecked: false,
  },
  {
    name: 'servicesOffered',
    label: 'Services provided',
    isChecked: false,
  },
];

export const dentalSpecificDefaultItems: CompareCheckboxInfo[] = [
  {
    name: 'reviews',
    label: 'Ratings',
    isChecked: true,
  },
  {
    name: 'education',
    label: 'Education',
    isChecked: false,
  },
  {
    name: 'languagesSpoken',
    label: 'Language(s) spoken',
    isChecked: false,
  },
  {
    name: 'cost',
    label: 'Cost',
    isChecked: true,
  },
  {
    name: 'specialties',
    label: 'Specialty',
    isChecked: true,
  },
  {
    name: 'distance',
    label: 'Distance from me',
    isChecked: true,
  },
  {
    name: 'acceptingNewPatients',
    label: 'Accepting new patients',
    isChecked: true,
  },
  {
    name: 'gender',
    label: 'Gender',
    isChecked: false,
  },
  {
    name: 'hoursOfOperation',
    label: 'Hours of operation',
    isChecked: false,
  },
];
export const NULL_ATTRIBUTE_STATE = {
  SPECIALTY: 'Specialty information not available',
  LANGUAGES_SPOKEN: 'Languages spoken information not available',
  ACCEPTING_NEW_PATIENTS: 'Accepting new patients information not available',
  GENDER: 'Gender information not available',
  HEALTH_GRADE_RATINGS: 'Ratings information not available',
  VIRTUAL_CARE_OFFERED: 'Virtual care information not available',
  DISTANCE: 'Distance information not available',
  ADDRESS: 'Address information not available',
  PHONE_NUMBER: 'Phone number not available',
  HOURS_OF_OPERATION: 'Hours of operation not available',
  TIER_ONE_PROVIDER: 'Tier 1 information not available',
  PREMIUM_CARE_PROVIDER: 'Premium Care Physician information not available',
  PCP_SERVICES_AVAILABILE: 'PCP Services information not available',
  EDUCATION_SCHOOLS: 'University information not available',
  EDUCATION_DEGREES: 'Degree information not available',
  PROVIDER_ETHNICITY: 'Provider Ethnicity information not available',
  EXPRESS_ACCESS_PROVIDER: 'Express Access Provider information not available',
  OFFERS_EVENING_APPOINTMENTS: 'Evening appointments information not available',
  OFFERS_WEEKEND_APPOINTMENTS: 'Weekend appointments information not available',
  PRACTICE_LIMITATIONS: 'Practice Limitations information not available',
  SERVICES_OFFERED: 'Services provided information not available',
  EAP_ACCEPTED:
    'Employee Assistance Program accepted information not available',
};

export const ATTRIBUTE_STATUS_TEXT = {
  ACCEPTING_NEW_PATIENTS: {
    TRUE: 'Accepting new patients',
    FALSE: 'Not accepting new patients',
  },
  VIRTUAL_CARE_OFFERED: {
    TRUE: 'Offers virtual care',
    FALSE: 'Does not offer virtual care',
  },
  TIER_ONE_PROVIDER: {
    TRUE: 'Tier 1 Provider',
    FALSE: 'Not a Tier 1 Provider',
  },
  TIER_TWO_PROVIDER: {
    TRUE: 'Tier 2 Provider',
    FALSE: 'Not a Tier 1 Provider',
  },
  PREMIUM_CARE_PROVIDER: {
    TRUE: 'Premium Care Physician',
    FALSE: 'Not a Premium Care Physician',
  },
  PCP_SERVICES_AVAILABILE: {
    TRUE: 'PCP services available',
    FALSE: 'PCP services not available',
  },
  OFFERS_EVENING_APPOINTMENTS: {
    TRUE: 'Offers evening appointments',
    FALSE: 'Does not offer evening appointments',
  },
  OFFERS_WEEKEND_APPOINTMENTS: {
    TRUE: 'Offers weekend appointments',
    FALSE: 'Does not offer weekend appointments',
  },
  PRACTICE_LIMITATIONS: {
    TRUE: 'Practice limitations',
    FALSE: 'No Practice limitations',
  },
  EXPRESS_ACCESS_PROVIDER: {
    TRUE: 'Express Access Provider',
    FALSE: 'Not an Express Access Provider',
  },
  EAP_ACCEPTED: {
    TRUE: 'Employee Assistance Program accepted',
    FALSE: '--',
  },
};

export const MAX_NUM_OF_ATTRIBUTES = 7; // in-Network/Not-In-Network is the 8th attribute on Edit Compare Floating section

export const adobeCompareDrawerLinkLocation = 'compare drawer';

export const CHECKBOX_ITEM_NAMES = {
  COST: 'cost',
  PREMIUM_CARE_PROVIDER: 'premiumCareProvider',
  REVIEWS: 'reviews',
  TIER: 'tier',
  TIER_PROVIDER: 'tierOneProvider',
  TIER_2_PROVIDER: 'tierOneAndTwoProvider',
  VIRTUAL_CARE_OFFERED: 'virtualCareOffered',
  ETHNICITY: 'ethnicity',
  PROVIDER_RACE: 'race',
};

export const defaultItemsSmartChoice: CompareCheckboxInfo[] = [
  //Basic information === 0
  {
    name: 'specialties',
    label: 'COMPARE_EDIT_SPECIALTY',
    isChecked: true,
    isDisabled: false,
    heading: 'basic',
  },
  {
    name: 'hasPCPServiceAvailability',
    label: 'COMPARE_EDIT_PCP_SERVICE',
    isChecked: true,
    isDisabled: false,
    heading: 'basic',
  },
  //Quality === 2
  {
    name: 'premiumCareProvider',
    label: 'COMPARE_EDIT_PREMIUM_CARE',
    isChecked: true,
    isDisabled: false,
    heading: 'quality',
  },
  {
    name: 'credentials',
    label: 'COMPARE_EDIT_CREDENTIALED',
    isChecked: true,
    isDisabled: false,
    heading: 'quality',
  },
  {
    name: 'serviceData',
    label: 'COMPARE_EDIT_SERVICE_DATA',
    isChecked: true,
    isDisabled: false,
    heading: 'quality',
  },

  //Benefit === 4
  {
    name: 'networkStatus',
    label: 'COMPARE_EDIT_NETWORK_STATUS',
    isChecked: true,
    isDisabled: false,
    heading: 'benefits',
  },
  {
    name: 'tier',
    label: 'COMPARE_EDIT_TIER',
    isChecked: true,
    isDisabled: false,
    heading: 'benefits',
  },
  {
    name: 'greenDiamond',
    label: 'COMPARE_EDIT_GREEN_DIAMOND',
    isChecked: true,
    isDisabled: false,
    heading: 'benefits',
  },
  {
    name: 'acoAffiliation',
    label: 'COMPARE_EDIT_AFFILIATION',
    isChecked: true,
    isDisabled: false,
    heading: 'benefits',
  },
  {
    name: 'costIndicator',
    label: 'COMPARE_EDIT_COST_INDICATOR',
    isChecked: true,
    isDisabled: false,
    heading: 'benefits',
  },
  {
    name: 'costEfficiency',
    label: 'COMPARE_EDIT_TOTAL_COST_OF_CARE',
    isChecked: true,
    isDisabled: false,
    heading: 'benefits',
  },
  //Convenience === 9
  {
    name: 'acceptingNewPatients',
    label: 'COMPARE_EDIT_ACCEPTING_NEW_PATIENTS',
    isChecked: true,
    isDisabled: false,
    heading: 'convenience',
  },
  {
    name: 'appointmentAvailability',
    label: 'COMPARE_EDIT_HOURS_OF_OPERATION',
    isChecked: true,
    isDisabled: false,
    heading: 'convenience',
  },
  {
    name: 'hasEveningAppointments',
    label: 'COMPARE_EDIT_EVENING_AVAILABILITY',
    isChecked: true,
    isDisabled: false,
    heading: 'convenience',
  },
  {
    name: 'hasWeekendAppointment',
    label: 'COMPARE_EDIT_WEEKEND_AVAILABILITY',
    isChecked: true,
    isDisabled: false,
    heading: 'convenience',
  },
  {
    name: 'onlineAppointmentScheduling',
    label: 'COMPARE_EDIT_ONLINE_AVAILABILITY',
    isChecked: true,
    isDisabled: false,
    heading: 'convenience',
  },
  {
    name: 'virtualCareOffered',
    label: 'COMPARE_EDIT_VIRTUAL_APPOINTMENT',
    isChecked: true,
    isDisabled: false,
    heading: 'convenience',
  },
  {
    name: 'distance',
    label: 'COMPARE_EDIT_DISTANCE',
    isChecked: true,
    isDisabled: false,
    heading: 'convenience',
  },

  //Personal Fit === 18
  {
    name: 'languageSpoken',
    label: 'COMPARE_EDIT_LANGUAGE_SPOKEN',
    isChecked: true,
    isDisabled: false,
    heading: 'personalFit',
  },
  {
    name: 'gender',
    label: 'COMPARE_EDIT_GENDER',
    isChecked: true,
    isDisabled: false,
    heading: 'personalFit',
  },
  {
    name: 'race',
    label: 'COMPARE_EDIT_RACE',
    isChecked: true,
    isDisabled: false,
    heading: 'personalFit',
  },
  {
    name: 'ethnicity',
    label: 'COMPARE_EDIT_ETHNICITY',
    isChecked: true,
    isDisabled: false,
    heading: 'personalFit',
  },
  {
    name: 'boardCertified',
    label: 'COMPARE_EDIT_BOARD_CERTIFIED',
    isChecked: true,
    isDisabled: false,
    heading: 'personalFit',
  },
  {
    name: 'reviews',
    label: 'COMPARE_EDIT_RATINGS',
    isChecked: true,
    isDisabled: false,
    heading: 'personalFit',
  },
];

export const noAttributesDisplayed = (
  defaultItems: CompareCheckboxInfo[],
  attributes: string[]
): boolean => {
  const defaultAttributeNames = defaultItems.map((item) => item.name);
  return attributes.every(
    (attribute) =>
      defaultAttributeNames.includes(attribute) &&
      defaultItems.find((item) => item.name === attribute)?.isChecked === false
  );
};

export const QUALITY_ATTRIBUTES = [
  'premiumCareProvider',
  'credentials',
  'serviceData',
];
export const BENEFIT_ATTRIBUTES = [
  'networkStatus',
  'tier',
  'acoAffiliation',
  'greenDiamond',
  'costIndicator',
  'costEfficiency',
];
export const CONVENIENCE_ATTRIBUTES = [
  'acceptingNewPatients',
  'appointmentAvailability',
  'hasEveningAppointments',
  'hasWeekendAppointment',
  'onlineAppointmentScheduling',
  'virtualCareOffered',
  'distance',
];
export const PERSONAL_FIT_ATTRIBUTES = [
  'languageSpoken',
  'gender',
  'race',
  'boardCertified',
  'reviews',
  'ethnicity',
];
